import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIGetData } from '../APIS/wupuapAPI.js';
import axios from 'axios';

const BASE_URL = 'https://portal.ttpadvisory.co.uk:3556/api/ch';
// api/ch/getcompanyofficers/:cnumber - Get Company Details
// api/ch/getcompanydetails/:cnumber - Get Office Details
const initialState = {
  companyName: '',
  companyNumber: '',
  mainContact: '',
  company: {},
  officers: [],
  filings: [],
  items_per_page: 100,    //Company House API Max 100 Items per page.
  page: 0,                // Page to fthe Filings to retrieve.
  registered_office_address: '',
  columns: "",
  loading: false,
  error: null,
  loaded: false,
  viewChouseDetails: false,
  updatedat: null
};

export const fetchCompanyDetails = createAsyncThunk(
  'chouse/fetchCompanyDetails',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().chouse;
    const {
      companyNumber,
    } = state;

    try {
      const token = getState().auth.token;
      const url =`${BASE_URL}/getcompanydetails/${companyNumber}`
        const response = await axios.get(url,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
      if(response.status===200 && response.statusText ==='OK')
        return response.data
      else 
        return {status: false, data: null, err: `Problem retrieving Data ${response.status}/${response.statusText}` }
      return response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchCompanyFilings = createAsyncThunk(
  'chouse/fetchCompanyFilings',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().chouse;
    const {
      companyNumber,
      items_per_page,
      page
    } = state;

    try {
      const token = getState().auth.token;
      const url =`${BASE_URL}/getcompanyfilings/${companyNumber}`
        const response = await axios.post(url,
          {page, items_per_page},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
      return response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchCompanyOfficers = createAsyncThunk(
  'chouse/fetchCompanyOfficers',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().chouse;
    const {
      companyNumber,
    } = state;

    try {
      const token = getState().auth.token;
      const url =`${BASE_URL}/getcompanyofficers/${companyNumber}`
        const response = await axios.get(url,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
      return response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);




const chouseSlice = createSlice({
  name: 'chouse',
  initialState,
  reducers: {
    setCompanyName: (state,action) => {
      state.companyName = action.payload
    },
    setCompanyNumber: (state,action) => {
      state.companyNumber = action.payload;
    },
    setMainContact: (state,action) => {
      state.mainContact = action.payload
    },
    setViewChouseDetails: (state,action) =>{
      state.viewChouseDetails = action.payload
    },
    setAuth: (state, action) => { state.auth = action.payload; },
    setItemsPerPage: (state,action) => {state.items_per_page = action.payload },
    setPage: (state,action) => {state.page = action.payload }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyDetails.pending, (state) => {
        state.loading = true;
        state.loaded = false;
        state.error = null;
      })
      .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
        if(!action.payload.status)
          return state
        const company = action.payload.data || {};
        state.updatedat = new Date().toISOString()
        state.company = company;
        state.loading = false;
        state.loaded = true;
        const { address_line_1,address_line_2,country,locality,postal_code} = company.registered_office_address
        var regaddr = address_line_1
        if(address_line_2) 
          regaddr += `, ${address_line_2}`
        if(locality && locality !== address_line_2) 
          regaddr += `, ${locality}`
        if(country) 
          regaddr += `, ${country}`
        if(postal_code) 
          regaddr += `, ${postal_code}`
        state.registered_office_address = regaddr
      })
      .addCase(fetchCompanyDetails.rejected, (state, action) => {
          state.loading = false;
          state.loaded = false;
          state.error = action.payload || 'Fetch failed';
      })

      .addCase(fetchCompanyFilings.pending, (state) => {
        state.loading = true;
        state.loaded = false;
        state.error = null;
      })
      .addCase(fetchCompanyFilings.fulfilled, (state, action) => {
        const filings = action.payload.data.data || {};
        state.filings = filings;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(fetchCompanyFilings.rejected, (state, action) => {
        state.loading = false;
        state.loaded = false;
        state.error = action.payload || 'Fetch failed';
      })

      // fetchCompanyOfficers
      .addCase(fetchCompanyOfficers.pending, (state) => {
        state.loading = true;
        state.loaded = false;
        state.error = null;
      })
      .addCase(fetchCompanyOfficers.fulfilled, (state, action) => {
        const officers = action?.payload?.data?.data?.items || [];
        state.officers = officers;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(fetchCompanyOfficers.rejected, (state, action) => {
        state.loading = false;
        state.loaded = false;
        state.error = action.payload || 'Fetch failed';
      })

  }
});

export const {
  setCompanyName,
  setCompanyNumber,
  setMainContact,
  setActiveOfficer,
  setViewChouseDetails,
  setItemsPerPage,
  setPage
} = chouseSlice.actions;

export default chouseSlice.reducer;